import { gql } from "@apollo/client";

export const SAVE_ONBOARDING_FILES_MUTATION = gql`
  mutation SaveOnBoardingFiles($input: SaveOnBoardingFilesInput!) {
    saveOnBoardingFiles(input: $input) {
       file_urls
        conversation_id
    }
  }
`;

export const UPDATE_INSPECTION_ORDER_MUTATION = gql`
mutation UpdateInspectionOrder($input: UpdateInspectionOrderInput!) { 
    updateInspectionOrder(input: $input) { 
        id 
        name 
        locationDescription 
        dueDate 
        assignedBy 
        approvedBy 
        approvedDate 
        completedBy 
        completedDate 
        status 
        options 
    } 
}
`;

export const CREATE_INSPECTION_ORDER_MUTATION = gql`
mutation CreateInspectionOrder($input: CreateInspectionOrderInput!) { 
    createInspectionOrder(input: $input) { 
        id 
        name 
        locationDescription 
        dueDate 
        assignedBy 
        approvedBy 
        approvedDate 
        completedBy 
        completedDate 
        status 
        options 
        createdAt 
    } 
}
`;

export const DELETE_INSPECTION_ORDER_MUTATION = gql`
mutation DeleteInspectionOrder($id: ID!) {
    deleteInspectionOrder(id: $id)
}
`;

export const UPDATE_INSPECTION_ASSET_MUTATION = gql`
mutation UpdateInspectionAsset($input: UpdateInspectionAssetInput!) { 
    updateInspectionAsset(input: $input) { 
      id
        assetId
        inspectionOrderId
        inspectionStatus
        userNotes
        attachments
        completedBy
        completedAt
        approvedBy
        approvedAt
        approverNotes
         completedByUser {
            id
            email
            firstName
            lastName
            twoFactorEnabled
        }
        approvedByUser {
            id
            email
            firstName
            lastName
            role
        } 
        assets {
            id
            name
            description
            productId
            serialNumber
            installationDate
            lastServiceDate
            lastInspectionDate
            locationIds
            locationAddress
            fileIds
            position
            createdAt
            updatedAt
            deletedAt
            status
            parentId
            information
            coverage
            maintenance
            upcomingInspection
            locations {
                id
                locationName
            }
}
    } 
}
`;

export const UPDATE_INSPECTION_ASSET_APPROVER_NOTES_MUTATION = gql`
mutation UpdateInspectionAssetApproverNotes($input: UpdateInspectionAssetInput!) {
    updateInspectionAsset(input: $input) {
        id
        approverNotes
        approvedBy
    }
}
`;

export const REOPEN_INSPECTION_ASSET_MUTATION = gql`
mutation ReopenInspectionAsset($input: UpdateInspectionAssetInput!) {
    updateInspectionAsset(input: $input) {
        id
        inspectionStatus
        completedAt
        completedBy
    }
}
`;

export const SEED_INSPECTION_OBLIGATION_TASKS_MUTATION = gql`
  mutation SeedInspectionObligationTasks($inspectionOrderId: ID!, $assetIds: [ID!]) {
    seedInspectionObligationTasks(inspectionOrderId: $inspectionOrderId, assetIds: $assetIds) {
      inspectionOrderId
      obligationResultsCreated
      tasksCreated
    }
  }
`;

export const RECOMPUTE_INSPECTION_ASSET_STATUS_MUTATION = gql`
  mutation RecomputeInspectionAssetStatus($inspectionOrderId: ID!, $assetId: ID!) {
    recomputeInspectionAssetStatus(inspectionOrderId: $inspectionOrderId, assetId: $assetId) {
      inspectionAssetId
      inspectionStatus
      updated
      orderStatus
      orderUpdated
    }
  }
`;

export const RECONCILE_INSPECTION_EVIDENCE_FULFILLMENT_MUTATION = gql`
  mutation ReconcileInspectionEvidenceFulfillment($inspectionOrderId: ID!, $assetId: ID!) {
    reconcileInspectionEvidenceFulfillment(inspectionOrderId: $inspectionOrderId, assetId: $assetId) {
      inspectionOrderId
      assetId
      inspectionAssetId
      inspectionStatus
      assetUpdated
      orderStatus
      orderUpdated
      obligationResultsUpdated
    }
  }
`;

export const GENERATE_INSPECTION_EVIDENCE_FORM_MUTATION = gql`
  mutation GenerateInspectionEvidenceForm($inspectionOrderId: ID!, $assetId: ID!) {
    generateInspectionEvidenceForm(inspectionOrderId: $inspectionOrderId, assetId: $assetId) {
      created
      ticketsCreated
      form {
        id
        status
        tickets {
          id
          code
          title
          evidenceLabel
          questions
          answers
          result
          coveredObligationIds
        }
      }
    }
  }
`;

export const UPDATE_EVIDENCE_TICKET_MUTATION = gql`
  mutation UpdateEvidenceTicket($id: ID!, $input: UpdateEvidenceTicketInput!) {
    updateEvidenceTicket(id: $id, input: $input) {
      id
      code
      answers
      result
      attachments {
        id
        documentId
        attachmentRole
        questionId
      }
    }
  }
`;

export const SUBMIT_INSPECTION_EVIDENCE_FORM_MUTATION = gql`
  mutation SubmitInspectionEvidenceForm($formId: ID!) {
    submitInspectionEvidenceForm(formId: $formId) {
      id
      status
      submittedAt
      tickets {
        id
        result
      }
    }
  }
`;

export const EXPORT_INSPECTION_EVIDENCE_FORM_MUTATION = gql`
  mutation ExportInspectionEvidenceForm($formId: ID!, $format: EvidenceFormExportFormat!) {
    exportInspectionEvidenceForm(formId: $formId, format: $format) {
      documentId
      downloadUrl
      contentBase64
      fileName
      format
    }
  }
`;

export const IMPORT_INSPECTION_EVIDENCE_FORM_MUTATION = gql`
  mutation ImportInspectionEvidenceForm($formId: ID!, $documentId: ID!) {
    importInspectionEvidenceForm(formId: $formId, documentId: $documentId) {
      ticketsUpdated
      form {
        id
        status
        tickets {
          id
          code
          answers
          result
        }
      }
    }
  }
`;

export const EXPORT_INSPECTION_ORDER_EVIDENCE_MUTATION = gql`
  mutation ExportInspectionOrderEvidence($inspectionOrderId: ID!, $format: EvidenceFormExportFormat!) {
    exportInspectionOrderEvidence(inspectionOrderId: $inspectionOrderId, format: $format) {
      documentId
      downloadUrl
      contentBase64
      fileName
      format
    }
  }
`;

export const IMPORT_INSPECTION_ORDER_EVIDENCE_MUTATION = gql`
  mutation ImportInspectionOrderEvidence($inspectionOrderId: ID!, $documentId: ID!) {
    importInspectionOrderEvidence(inspectionOrderId: $inspectionOrderId, documentId: $documentId) {
      assetsUpdated
      ticketsUpdated
      forms {
        id
        status
        assetId
        tickets {
          id
          code
          answers
          result
        }
      }
    }
  }
`;

// Assistant Chat Mutations
